import React from 'react';
// @ts-ignore
import { Table } from '@els/els-react--table';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
import { ISkillFavoriteContent } from '../../../../libs/utils/interfaces/ebpc-interface';
import SkillsFavoriteListRow from './favorite-content-list-row';
import './favorite-content-list.scss';

const SkillsFavoriteList = (props: any) => {
    const { favoriteSkillList, isSorting, handleRedirectToSkillDetail } = props;

    const headers = [
        {
            value: 'skillName',
            label: 'Skill Title',
        },
        {
            value: 'dateUpdated',
            label: 'Date Favorited',
        },
        {
            value: 'remove',
            label: 'Remove',
        },
    ];
    const baseClassName = 'skills-favorite-list-wrapper';
    return (
        <div>
            <div className={`${baseClassName}__container`}>
                {isSorting ? (
                    <Loader isVisible isBlocking={false} />
                ) : (
                    <div className={`${baseClassName}`}>
                        <Table
                            className={`${baseClassName}__container__skill-favorite-list`}
                            a11y={{
                                name: 'User favorite skills list',
                                description: 'User favorite skills list',
                                showDescription: false,
                            }}
                            data={favoriteSkillList}
                            columns={headers}
                            renderDatum={
                                (data: any) =>
                                    data.map(
                                        ({
                                            id,
                                            skillName,
                                            dateUpdated,
                                            courseId,
                                        }: ISkillFavoriteContent) => (
                                            <SkillsFavoriteListRow
                                                key={id}
                                                id={id}
                                                courseId={courseId}
                                                skillTitle={skillName}
                                                favoriteDate={dateUpdated}
                                                className={`${baseClassName}__container__skill-favorite-list`}
                                                handleRedirectToSkillDetail={
                                                    handleRedirectToSkillDetail
                                                }
                                            />
                                        )
                                    )
                                // eslint-disable-next-line react/jsx-curly-newline
                            }
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default SkillsFavoriteList;
